export enum ExercisePageMode {
  Learner = 'LEARNER',
  Reviewer = 'REVIEWER',
}
